import request from "./request";

const Grupo = {
  consultar: criterio =>
    request.get("/composicao/grupos", {
      params: {
        page: criterio.pagina,
        limit: criterio.limite
      }
    }),
  cadastrar: grupo => request.post("/composicao/grupos", grupo),
  alterar: grupo => request.put(`/composicao/grupos/${grupo.ID}`, grupo),
  excluir: ids =>
    request.del("/composicao/grupos", {
      params: {
        id: [].concat(ids).join(",")
      }
    }),
  buscar: id => request.get(`/composicao/grupos/${id}`)
};

export default Grupo;



// WEBPACK FOOTER //
// ./src/services/grupo.js